import Api from './Api'
import _ from 'lodash'

function composeQueryString(filter, sort, page, size) {

  let qs = ''

  if (filter) { qs = filter}
  
  if (sort) {
    if (qs) { qs = qs + '&sort=' + sort} else { qs = 'sort=' + sort }
  }

  if (!_.isNil(page)) {
    if (qs) { qs = qs + '&page=' + page} else { qs = 'page=' + page }
  }

  if (!_.isNil(size)) {
    if (qs) { qs = qs + '&size=' + size} else { qs = 'size=' + size }
  }

  if (qs) {
    qs = '?' + qs
  }

  console.log('QS = ' + qs)

  return qs
}

export default {
  async getIntegrationTokens(filter, sort, page, size) {
    return new Api().get(`/admin/api/v1/integration_tokens?deleted=false`)
  },
  async updateIntegrationToken(patchObject) {
    return new Api().patch(`/admin/api/v1/integration_tokens`, patchObject)
  },
  async upsertIntegrationToken(updateObject) {
    return new Api().put(`/admin/api/v1/integration_tokens`, updateObject)
  },
  async deleteIntegrationToken(updateObject) {
    return new Api().delete(`/admin/api/v1/integration_tokens/${updateObject.id}`)
  },
  async getOrgApprovals(filter, sort, page, size) {
    return new Api().get(`/admin/api/v1/org_approvals`)
  },
  async updateOrgApproval(patchObject) {
    return new Api().patch(`/admin/api/v1/org_approvals`, patchObject)
  },
  async upsertOrgApproval(updateObject) {
    return new Api().put(`/admin/api/v1/org_approvals`, updateObject)
  },
  async approveOrg(approval) {
    return new Api().post(`/userreg/api/v1/user_requests/approve`, approval)
  },
  async deleteOrgApproval(updateObject) {
    return new Api().delete(`/admin/api/v1/org_approvals/${updateObject.id}`)
  },
  async getSystems(filter, sort, page, size) {
    return new Api().get(`/admin/api/v1/systems${composeQueryString(filter, sort, page, size)}`)
  },
  async getEndpoints(filter, sort, page, size) {
    return new Api().get(`/admin/api/v1/endpoints${composeQueryString(filter, sort, page, size)}`)
  },
  async getTypeCodes(filter, sort, page, size) {
    return new Api().get(`/admin/api/v1/su/type_codes${composeQueryString(filter, sort, page, size)}`)
  },
  async getCodeSets() {
    return new Api().get(`/admin/api/v1/codesets`)
  },
  async getAccessGroups(filter, sort, page, size) {
    return new Api().get(`/admin/api/v1/access_groups${composeQueryString(filter, sort, page, size)}`)
  },
  async getAppConfigs(filter, sort, page, size) {
    return new Api().get(`/admin/api/v1/appconfigs${composeQueryString(filter, sort, page, size)}`)
  },
  async getWorkerSessions(filter, sort, page, size) {
    return new Api().get(`/admin/api/v1/worker_sessions${composeQueryString(filter, sort, page, size)}`)
  },
  async getUsers(filter, sort, page, size) {
    return new Api().get(`/admin/api/v1/users${composeQueryString(filter, sort, page, size)}`)
  },
  async getAuditHistory(filter, sort, page, size) {
    return new Api(true).get(`/admin/api/v1/audit_history${composeQueryString(filter, sort, page, size)}`)
  },
  async getDatafeed(filter, sort, page, size) {
    return new Api(true).get(`/admin/api/v1/datafeed${composeQueryString(filter, sort, page, size)}`)
  },
  async updateSystem(system, patchObject, pwd) {
    let qualifier = pwd ? '?pwd=true' : ''
    return new Api().patch(`/admin/api/v1/orgs/${system.org.id}/systems/${system.id + '' + qualifier}`, patchObject)
  },
  async updateEndpoint(endpoint, patchObject, pwd) {
    let qualifier = pwd ? '?pwd=true' : ''
    return new Api().patch(`/admin/api/v1/orgs/${endpoint.org.id}/endpoints/${endpoint.id + '' + qualifier}`, patchObject)
  },
  async updateUser(user, patchObject) {
    return new Api().patch(`/admin/api/v1/orgs/${user.org.id}/users/${user.id}`, patchObject)
  },
  async updateTypeCode(typeCode, patchObject) {
    return new Api().patch(`/admin/api/v1/type_codes/${typeCode.id}`, patchObject)
  },
  async upsertTypeCode(updateObject) {
    return new Api().put(`/admin/api/v1/type_codes`, updateObject)
  },
  async updateOrg(org, patchObject) {
    return new Api().patch(`/admin/api/v1/orgs/${org.id}`, patchObject)
  },
  async purgeOrg(orgId) {
    return new Api().delete(`/admin/api/v1/orgs/${orgId}`)
  },
  async updateConfig(config) {
    return new Api().put(`/admin/api/v1/orgs/${config.orgId}/appconfigs`, config)
  },
  async getToken(orgId, userId) {
    return new Api().get('/admin/api/v1/orgs/' + orgId + '/users/' + userId + '/token')
  },
  async getOrganization(id) {
    return new Api().get('/admin/api/v1/orgs/' + id)
  },
  async getReportModules() {
    return new Api().get('/admin/api/v1/report_modules')
  },
  async createOrganization(orgReqData) {
    return new Api().post('/admin/api/v1/orgs', orgReqData)
  }
}